import React from "react";
import NoRecordFound from "../Common/NoRecordFound";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";

function OverViewAlertPage() {
  const { t } = useTranslation();
  const ALERTS_DATA = [
    {
      id: 1,
      title: t("Manuel Queue Time Increase"),
      value: t("10 min"),
      store: t("Store - Al arid, Riyadh"),
      time: t("1 min ago"),
      type: "error", // error | success
    },
    {
      id: 2,
      title: t("System Operations Started"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "success",
    },
    {
      id: 3,
      title: t("Manuel Intervention"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "error",
    },
    {
      id: 4,
      title: t("Manuel Queue Time Increase"),
      value: t("10 min"),
      store: t("Store - Al arid, Riyadh"),
      time: t("1 min ago"),
      type: "error", // error | success
    },
    {
      id: 5,
      title: t("System Operations Started"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "success",
    },
    {
      id: 6,
      title: t("Manuel Intervention"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "error",
    },
  ];

  return (
    <div className="page-content common_details_page alert_page">
      <PageHeader
        title={t("Alerts")}
        isBackBtn
        className="details_page_title"
      />

      <div className="alerts__list common_scrollbar">
        {ALERTS_DATA?.length === 0 ? (
          <NoRecordFound title={t("No alerts found")} />
        ) : (
          ALERTS_DATA?.map((alert) => (
            <div
              key={alert.id}
              className={`alert_card alert_card--${alert.type}`}
            >
              <div className="alert_card__content">
                <h4>{alert.title}</h4>

                {alert.value && (
                  <p className="alert_card__value">{alert.value}</p>
                )}

                <p className="alert_card__store">{alert.store}</p>
              </div>

              <span className="alert_card__time">{alert.time}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default OverViewAlertPage;
